export interface ProductFaqItem {
  question: string;
  answer: string;
}

export const productFaqs: Record<string, ProductFaqItem[]> = {
  bt950: [
    {
      question: 'Qual a espessura máxima de geomembrana que o BT950 consegue soldar?',
      answer: 'O BT950 solda geomembranas de PEAD, PELBD e PVC com espessuras de 500 a 3000 microns (0,5 a 3,0 mm). É o modelo mais potente da linha, ideal para aterros sanitários, mineração e grandes reservatórios onde as geomembranas são mais espessas.',
    },
    {
      question: 'Qual a diferença entre o BT950 e uma máquina de cunha quente menor?',
      answer: 'O BT950 possui 2100W de potência, velocidade de 5 a 8 m/min e temperatura até 500°C com controle digital. Modelos menores como o BT800 (800W) são indicados para espessuras menores (até 1500 mic) e obras de menor escala. O BT950 é projetado para produtividade máxima em grandes projetos.',
    },
    {
      question: 'A Soldageo faz envio do BT950 para todo o Brasil?',
      answer: 'Sim. Realizamos envio para todos os 26 estados brasileiros e o Distrito Federal. O prazo médio de entrega varia de 3 a 10 dias úteis, dependendo da localidade. O equipamento é enviado embalado com proteção adequada para transporte.',
    },
    {
      question: 'Qual a garantia do BT950 e como funciona o suporte técnico?',
      answer: 'O BT950 possui garantia de 6 meses contra defeitos de fabricação. O suporte técnico é realizado por nossa equipe especializada via WhatsApp, com atendimento em todo o Brasil. Disponibilizamos peças de reposição originais, manuais técnicos em português e orientação para calibração.',
    },
    {
      question: 'O BT950 trabalha com 110V ou apenas 220V?',
      answer: 'O BT950 opera em 220V / 50-60Hz. Recomendamos verificar a disponibilidade de energia no local da obra antes da aquisição. Para locais com apenas 110V, podemos orientar sobre soluções técnicas compatíveis.',
    },
    {
      question: 'Qual a largura de solda que o BT950 produz?',
      answer: 'O BT950 produz soldas com largura de 40 mm, atendendo aos padrões técnicos exigidos em projetos de impermeabilização profissional. A largura uniforme garante selagem hermética e resistência mecânica adequada.',
    },
  ],
  bt1600: [
    {
      question: 'O BT1600 é adequado para que tipo de projetos?',
      answer: 'O BT1600 é ideal para projetos de médio e grande porte que exigem produtividade consistente. Com 1600W e velocidade de 5 m/min, atende bem a lagoas, reservatórios, aquicultura e tratamento de efluentes com geomembranas de 400 a 2000 microns.',
    },
    {
      question: 'Qual a temperatura máxima de operação do BT1600?',
      answer: 'O BT1600 alcança temperaturas de até 450°C, com controle preciso que permite ajuste fino conforme o material e espessura da geomembrana. Essa faixa é suficiente para soldagem profissional de PEAD, PELBD e PVC.',
    },
    {
      question: 'O BT1600 é mais leve que o BT950?',
      answer: 'Sim. O BT1600 pesa 4,2 kg, enquanto o BT950 pesa 11 kg. O BT1600 é mais portátil e ideal para equipes que precisam de mobilidade em campo, sem abrir mão da potência e qualidade de solda profissional.',
    },
    {
      question: 'A Soldageo oferece treinamento para operação do BT1600?',
      answer: 'Sim. Oferecemos orientação técnica inicial via WhatsApp e vídeos exclusivos de operação. Para equipes que necessitam treinamento presencial, consultamos a disponibilidade conforme a região. Todo equipamento é acompanhado de manual técnico em português.',
    },
    {
      question: 'Qual a garantia e política de devolução do BT1600?',
      answer: 'O BT1600 possui garantia de 6 meses contra defeitos de fabricação. Em caso de defeito no recebimento, o equipamento pode ser trocado dentro do prazo legal. O suporte técnico pós-venda é permanente via WhatsApp com nossa equipe especializada.',
    },
  ],
  bt800: [
    {
      question: 'O BT800 é indicado para projetos pequenos?',
      answer: 'Sim. O BT800 é a solução ideal para projetos de menor escala, trabalhos em locais de difícil acesso ou como máquina secundária em grandes obras. Com 800W e design compacto de 4,5 kg, oferece mobilidade sem abrir mão da qualidade de solda profissional.',
    },
    {
      question: 'Qual a espessura máxima que o BT800 solda?',
      answer: 'O BT800 solda geomembranas de PEAD, PELBD e PVC com espessuras de 500 a 1500 microns (0,5 a 1,5 mm). É perfeito para aquicultura, piscicultura, irrigação e pequenos reservatórios.',
    },
    {
      question: 'Qual a velocidade de soldagem do BT800?',
      answer: 'O BT800 opera com velocidade de 2 a 5 m/min, ajustável conforme a espessura do material e as condições de campo. A velocidade menor permite maior controle em trabalhos detalhados.',
    },
    {
      question: 'O BT800 tem a mesma largura de solda que os modelos maiores?',
      answer: 'O BT800 produz soldas com largura de 30 mm, ligeiramente menor que os modelos BT950 e BT1600 (40 mm). Essa largura é adequada para as aplicações típicas deste modelo, mantendo a selagem hermética.',
    },
    {
      question: 'A Soldageo envia o BT800 para todo o Brasil?',
      answer: 'Sim. Enviamos o BT800 para todos os estados brasileiros. O prazo médio é de 3 a 10 dias úteis. O equipamento é embalado com proteção para transporte seguro.',
    },
    {
      question: 'Qual a garantia do BT800?',
      answer: 'O BT800 possui garantia de 12 meses contra defeitos de fabricação, o maior prazo da linha. O suporte técnico pós-venda é realizado via WhatsApp com nossa equipe especializada.',
    },
  ],
  'cx300-1400w': [
    {
      question: 'A Canex CX300 é fabricada na Suíça?',
      answer: 'A Canex CX300 é uma máquina de solda de cunha quente reconhecida mundialmente pela precisão e confiabilidade. É ideal para soldagem de geomembranas em projetos que exigem o mais alto padrão de qualidade.',
    },
    {
      question: 'Qual a potência e velocidade da CX300?',
      answer: 'A CX300 possui 1400W de potência e velocidade ajustável de 0,5 a 6 m/min. A velocidade variável permite adaptação fina conforme o material e a espessura da geomembrana, garantindo solda de alta qualidade.',
    },
    {
      question: 'Qual a espessura máxima que a CX300 solda?',
      answer: 'A CX300 solda geomembranas de 500 a 1800 microns. É ideal para projetos de aquicultura, lagoas, reservatórios e tratamento de efluentes onde a precisão é fundamental.',
    },
    {
      question: 'Qual a diferença entre a CX300 e o BT950?',
      answer: 'A CX300 (1400W, 0,5–6 m/min) é focada em precisão com velocidade ajustável fina. O BT950 (2100W, 5–8 m/min) é projetado para máxima produtividade em grandes obras. A escolha depende do tipo de projeto: precisão detalhada vs. produtividade em massa.',
    },
    {
      question: 'A CX300 tem garantia e suporte técnico no Brasil?',
      answer: 'Sim. A CX300 possui garantia de 12 meses. A Soldageo oferece suporte técnico pós-venda via WhatsApp para todo o Brasil, com peças de reposição e orientação para manutenção.',
    },
  ],
  ex3: [
    {
      question: 'Para que serve uma extrusora de geomembrana?',
      answer: 'A extrusora é utilizada para soldagem de reforço, reparos, cantos, junções e detalhes onde a cunha quente não alcança. Ela deposita material fundido (fio de PEAD) sobre a junta, criando uma solda de alta resistência mecânica. É indispensável em aterros sanitários e mineração.',
    },
    {
      question: 'Qual o diâmetro do fio que a EX3 utiliza?',
      answer: 'A Extrusora EX3 utiliza fio de PEAD com diâmetro de 3,0 a 4,0 mm. A Soldageo pode indicar fornecedores de fio compatível no Brasil ou orientar sobre a especificação técnica exata.',
    },
    {
      question: 'A EX3 substitui uma máquina de cunha quente?',
      answer: 'Não. A extrusora e a cunha quente são complementares. A cunha quente faz a solda principal contínua em sobreposição. A extrusora faz reparos, cantos, emendas de reforço e trabalhos em locais de difícil acesso. Em projetos profissionais, ambas são necessárias.',
    },
    {
      question: 'Qual a produção e temperatura da EX3?',
      answer: 'A EX3 produz 3,5 kg/h de material extrudado e alcança temperaturas de até 700°C. Com 3400W de potência, é capaz de soldar geomembranas espessas em condições adversas de campo.',
    },
    {
      question: 'A Soldageo vende o fio de PEAD para a EX3?',
      answer: 'A Soldageo orienta sobre a especificação do fio compatível e pode indicar fornecedores no Brasil. O fio de PEAD de Ø 3,0–4,0 mm é encontrado facilmente no mercado brasileiro de geomembranas.',
    },
    {
      question: 'Qual a garantia da Extrusora EX3?',
      answer: 'A Extrusora EX3 possui garantia de 12 meses contra defeitos de fabricação. O suporte técnico é realizado por nossa equipe via WhatsApp, com atendimento em todo o Brasil.',
    },
  ],
  wgw300: [
    {
      question: 'Qual a velocidade máxima do Weldy WGW300?',
      answer: 'O Weldy WGW300 alcança velocidades de 5 a 9 m/min, uma das mais altas da categoria. Essa produtividade é ideal para grandes obras de impermeabilização onde o cronograma é apertado.',
    },
    {
      question: 'O WGW300 é adequado para aterros sanitários?',
      answer: 'Sim. Com 2100W e capacidade de soldar geomembranas de 500 a 3000 microns, o WGW300 é perfeitamente adequado para aterros sanitários, mineração e grandes reservatórios. A alta velocidade aumenta a produtividade diária significativamente.',
    },
    {
      question: 'Qual a diferença entre o WGW300 e o BT950?',
      answer: 'Ambos possuem 2100W e soldam até 3000 microns. O WGW300 se destaca pela velocidade máxima de 9 m/min (vs. 8 m/min do BT950), sendo ideal para obras que priorizam produtividade. O BT950 tem controle digital de temperatura mais refinado. A escolha depende do perfil da obra.',
    },
    {
      question: 'O WGW300 tem controle de temperatura?',
      answer: 'Sim. O WGW300 possui controle de temperatura até 500°C, ajustável conforme o material e a espessura da geomembrana. O controle permite operação precisa em diferentes condições de campo.',
    },
    {
      question: 'A Soldageo envia o WGW300 para todo o Brasil?',
      answer: 'Sim. Enviamos para todos os estados brasileiros. O prazo médio de entrega é de 3 a 10 dias úteis. O equipamento é embalado com proteção adequada para transporte seguro.',
    },
    {
      question: 'Qual a garantia do Weldy WGW300?',
      answer: 'O Weldy WGW300 possui garantia de 6 meses contra defeitos de fabricação. O suporte técnico pós-venda é realizado via WhatsApp por nossa equipe especializada, com atendimento em todo o Brasil.',
    },
  ],
  'bt-gm1': [
    {
      question: 'O BT-GM1 é um modelo novo da Soldageo?',
      answer: 'Sim. O BT-GM1 é o mais novo modelo da linha Soldageo, com controle digital avançado e alta precisão de soldagem. Projetado para atender projetos que exigem máxima confiabilidade e desempenho consistente.',
    },
    {
      question: 'Qual a potência e velocidade do BT-GM1?',
      answer: 'O BT-GM1 possui 1800W de potência e velocidade ajustável de 0,5 a 7 m/min. A faixa de velocidade ampla permite adaptação a diferentes espessuras e tipos de geomembrana.',
    },
    {
      question: 'Qual a espessura máxima que o BT-GM1 solda?',
      answer: 'O BT-GM1 solda geomembranas de 500 a 2000 microns de PEAD, PELBD e PVC. É ideal para projetos de médio porte que exigem precisão e confiabilidade.',
    },
    {
      question: 'O BT-GM1 tem controle digital de temperatura?',
      answer: 'Sim. O BT-GM1 possui controle digital avançado de temperatura de até 550°C. O controle digital permite ajuste preciso e repetível, essencial para garantir a qualidade da solda em cada junta.',
    },
    {
      question: 'Qual a garantia do BT-GM1?',
      answer: 'O BT-GM1 possui garantia de 6 meses contra defeitos de fabricação. O suporte técnico é realizado via WhatsApp por nossa equipe especializada, com atendimento em todo o Brasil.',
    },
  ],
  'soprador-2000w-com-rolo': [
    {
      question: 'Para que serve o Soprador 2000W com Rolo?',
      answer: 'O Soprador 2000W com Rolo é um acessório profissional para soldagem manual de geomembranas. Com temperatura de até 650°C e rolo de pressão integrado, permite soldas precisas em reparos, cantos, detalhes e locais de difícil acesso onde uma máquina automática não alcança.',
    },
    {
      question: 'Qual a espessura máxima que o soprador solda?',
      answer: 'O Soprador 2000W com Rolo solda geomembranas de 200 a 2000 microns. É ideal para reparos rápidos, acabamentos e trabalhos em espessuras menores onde a precisão manual é necessária.',
    },
    {
      question: 'O soprador substitui uma máquina de cunha quente?',
      answer: 'Não. O soprador é um acessório complementar, ideal para reparos, acabamentos e locais de difícil acesso. A máquina de cunha quente é indispensável para soldagem contínua em grandes áreas. Ambos se complementam em uma obra profissional.',
    },
    {
      question: 'O rolo de pressão é removível?',
      answer: 'Sim. O rolo de pressão integrado pode ser ajustado ou removido conforme a necessidade do trabalho. Isso permite adaptação a diferentes tipos de junta e condições de campo.',
    },
    {
      question: 'Qual a garantia do Soprador 2000W?',
      answer: 'O Soprador 2000W com Rolo possui garantia de 6 meses contra defeitos de fabricação. O suporte técnico é realizado via WhatsApp por nossa equipe especializada.',
    },
  ],
  'extrusora-metabo-bt610a': [
    {
      question: 'O que diferencia a Extrusora Metabo BT610A das demais?',
      answer: 'A Extrusora Metabo BT610A é o novo modelo da linha, com 3400W de potência e temperatura de até 600°C. A marca Metabo é reconhecida mundialmente pela durabilidade e qualidade de construção de suas ferramentas profissionais.',
    },
    {
      question: 'Qual o diâmetro do fio compatível?',
      answer: 'A BT610A utiliza fio de PEAD com diâmetro de 3 a 4 mm, o padrão mais comum no mercado brasileiro de geomembranas.',
    },
    {
      question: 'A BT610A é indicada para que tipo de obra?',
      answer: 'A BT610A é ideal para reparos, cantos, junções e detalhes em projetos de aterros sanitários, mineração, reservatórios e lagoas onde a extrusão de reforço é necessária.',
    },
    {
      question: 'Qual a garantia da Extrusora Metabo BT610A?',
      answer: 'A Extrusora Metabo BT610A possui garantia de 6 meses contra defeitos de fabricação. O suporte técnico é realizado via WhatsApp por nossa equipe especializada em todo o Brasil.',
    },
  ],
  lc3000c: [
    {
      question: 'O LC3000C é uma máquina profissional?',
      answer: 'Sim. O LC3000C é uma máquina de solda geomembrana profissional com alta durabilidade e desempenho consistente. Com 1800W e velocidade de até 7 m/min, é ideal para projetos de grande escala que exigem produtividade confiável.',
    },
    {
      question: 'Qual a espessura máxima que o LC3000C solda?',
      answer: 'O LC3000C solda geomembranas de 400 a 1100 microns de PEAD, PELBD e PVC. É ideal para aquicultura, piscicultura, lagoas e projetos de irrigação.',
    },
    {
      question: 'Qual a temperatura de operação do LC3000C?',
      answer: 'O LC3000C opera com temperatura de até 600°C, ajustável conforme o material e a espessura da geomembrana. A faixa ampla permite adaptação a diferentes condições de campo.',
    },
    {
      question: 'A Soldageo envia o LC3000C para todo o Brasil?',
      answer: 'Sim. Enviamos para todos os estados brasileiros. O prazo médio é de 3 a 10 dias úteis. O equipamento é embalado com proteção adequada para transporte.',
    },
    {
      question: 'Qual a garantia do LC3000C?',
      answer: 'O LC3000C possui garantia de 6 meses contra defeitos de fabricação. O suporte técnico pós-venda é realizado via WhatsApp por nossa equipe especializada.',
    },
  ],
  'weldy-wgw300-plus': [
    {
      question: 'Qual a diferença entre o WGW300 Plus e o WGW300 padrão?',
      answer: 'O WGW300 Plus é a versão de alta velocidade, com 2000W e velocidade de 4 a 8 m/min. O modelo padrão WGW300 tem 2100W e velocidade de 5 a 9 m/min. O Plus oferece um balanço entre potência e velocidade com controle de temperatura digital refinado.',
    },
    {
      question: 'Qual a espessura máxima do WGW300 Plus?',
      answer: 'O WGW300 Plus solda geomembranas de 500 a 3000 microns, igual ao modelo padrão. É adequado para aterros sanitários, mineração e grandes reservatórios.',
    },
    {
      question: 'O WGW300 Plus tem controle digital?',
      answer: 'Sim. O WGW300 Plus possui controle digital de temperatura de até 520°C, permitindo ajuste preciso e repetível para garantir a qualidade da solda em cada projeto.',
    },
    {
      question: 'Qual a garantia do WGW300 Plus?',
      answer: 'O WGW300 Plus possui garantia de 6 meses contra defeitos de fabricação. O suporte técnico é realizado via WhatsApp por nossa equipe especializada em todo o Brasil.',
    },
  ],
  'extrusora-weldy-booster-ex3-plus': [
    {
      question: 'O que é a Extrusora Weldy Booster EX3 Plus?',
      answer: 'A Extrusora Weldy Booster EX3 Plus é a versão aprimorada da EX3, com maior potência e produtividade. Com 3400W e temperatura de até 600°C, é a escolha ideal para projetos que exigem soldas de alta resistência mecânica.',
    },
    {
      question: 'Qual a diferença entre a EX3 Plus e a EX3 padrão?',
      answer: 'A EX3 Plus (3400W, até 600°C) é a versão aprimorada da EX3 padrão (3400W, até 700°C). A Plus oferece melhorias em ergonomia, controle de temperatura e durabilidade. Ambas utilizam fio de PEAD de Ø 3,0–4,0 mm.',
    },
    {
      question: 'A EX3 Plus é indicada para aterros sanitários?',
      answer: 'Sim. A EX3 Plus é ideal para soldagem de reforço, reparos e junções em aterros sanitários, mineração e grandes reservatórios. A extrusão é indispensável para complementar a solda de cunha quente em projetos profissionais.',
    },
    {
      question: 'Qual a garantia da EX3 Plus?',
      answer: 'A Extrusora Weldy Booster EX3 Plus possui garantia de 6 meses contra defeitos de fabricação. O suporte técnico é realizado via WhatsApp por nossa equipe especializada em todo o Brasil.',
    },
  ],
};